import BundleBuilder from '../components/BundleBuilder';

export default function Bundle() {
  return (
    <main data-testid="bundle-page" className="pt-12">
      <section className="container-essenya pb-12">
        <div className="text-eyebrow mb-3">Bundle</div>
        <h1 className="font-display text-4xl md:text-6xl leading-[1.05] mb-4">Crea il tuo kit casa ESSENYA</h1>
        <p className="text-essenya-text text-lg max-w-2xl">Scegli i prodotti più adatti alla tua routine e crea il tuo bundle personalizzato.</p>
      </section>
      <BundleBuilder />
    </main>
  );
}
